/**
 * Single source of truth for the SS-4 replica's page geometry.
 *
 * The official form is US Letter with a uniform 36pt margin: a 540pt body
 * inside a 611.976 x 791.968pt sheet. Everything below is derived from that,
 * so changing SS4_CAPTURE_WIDTH_PX alone rescales the whole form correctly.
 *
 * The values are mirrored in `.fixed-width-container.ss4-wide` in
 * src/styles/ss4_form.css — a stylesheet can't read a TS constant, and the
 * CSS rule carries `!important`, which beats a plain inline style. Change both
 * together or the layout and the capture will disagree.
 *
 * Note the capture path grabs each #pdf-content-page-* SECTION, not the outer
 * container, so the page margin has to sit on the sections. The container
 * itself is padding-free.
 */
const PAGE_W_PT = 611.976;
const PAGE_H_PT = 791.968;
const MARGIN_PT = 36;

/** Render width of one page, in px. Wider = finer detail, same proportions. */
export const SS4_CAPTURE_WIDTH_PX = 2100;

export const PX_PER_PT = SS4_CAPTURE_WIDTH_PX / PAGE_W_PT;

/** A full US Letter sheet at the render width — the height budget per page. */
export const SS4_PAGE_HEIGHT_PX = Math.floor(PAGE_H_PT * PX_PER_PT);

/** The official's 36pt page margin. */
export const SS4_MARGIN_PX = Math.round(MARGIN_PT * PX_PER_PT);
